export const PIXEL_ACL_OBJECTS = [
    'PixelList',
    'ConversionPixelCreate',
    'ConversionPixelDetail',
    'RetargetingPixelCreate',
    'RetargetingPixelDetail',
    'PixelGenerationCreate'
];
